import translations from 'common/i18n/translations'

class I18n {
  static locale() {
    return locale()
  }

  static fetch(label, options) {
    return fetch(label, options)
  }

  static localize(date, options) {
    return localize(date, options)
  }

  static translate(label, options) {
    return translate(label, options)
  }

  static human_attribute_name(modelname, attribute, options) {
    return human_attribute_name(modelname, attribute, options)
  }

  static model_name(model, options) {
    return model_name(model, options)
  }
}

function locale() {
  let html = document.getElementsByTagName('html')
  let lang = html.lang || 'it'
  lang = lang.replace(/-.*$/, '')
  return lang;
}

function localize(date, format) {
  let time = false
  if(typeof date == 'string') {
    if(date.match(/\d{2}:\d{2}:\d{2}/)) time = true
    date = new Date(date)
  }
  if(format?.time === false) time = false
  let fmt = {}
  switch(format?.format) {
    case 'long':
      fmt = {year: 'numeric', month: 'long', day: '2-digit'}
      if(time) Object.assign(fmt, {hour: '2-digit', minute: '2-digit'})
      break;
    case 'short':
      fmt = {month: 'short', day: '2-digit'}
      if(time) Object.assign(fmt, {hour: '2-digit', minute: '2-digit'})
      break;
    default:
      fmt = {year: 'numeric', month: 'short', 'weekday' :'short', day: '2-digit'}
      if(time) Object.assign(fmt, {hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short'})
      break;
  }
  return Intl.DateTimeFormat(locale(), fmt).format(date)
}

function translate(label, options) {
  try {
    let translated = fetch(label)
    return interpolate(translated, options)
  } catch (error) {
    console.error(`I18n: ${label}: ${error}`)
    return `i18n: ${label.replace(/.*\./, '')}`
  }
}

function has_model_attributes(key) {
  try {
    return !!fetch(key)
  } catch (error) {
    return false;
  }
}

function human_attribute_name(modelname, attribute) {
  if(has_model_attributes(`activemodel.attributes.${underscore(modelname)}`)) {
    return translate(`activemodel.attributes.${underscore(modelname)}.${attribute}`)
  }
  return translate(`activerecord.attributes.${underscore(modelname)}.${attribute}`)
}

function has_model_name(key) {
  try {
    return !!fetch(key)
  } catch (error) {
    return false;
  }
}

function model_name(model, {count, ...rest} = {count: 1}) {
  let data
  if(has_model_name(`activemodel.models.${underscore(model)}`)) {
    data = translate(`activemodel.models.${underscore(model)}`)
  } else {
    data = translate(`activerecord.models.${underscore(model)}`)
  }
  let model_name
  if(data === Object(data)) { // data is a object
    if(count === 1 & Object.hasOwn(data, 'one')) model_name = data.one
    else if(count === 0 & Object.hasOwn(data, 'zero')) model_name = data.zero
    else if(Object.hasOwn(data, 'other')) model_name = data.other
  }
  if(typeof data == 'string') model_name = data
  if(!model_name) model_name = model
  return model_name
}

function recursive_fetch(tree, path) {
  var key;
  key = path.shift()
  if (tree[key]) {
    if (path.length > 0) {
      if (typeof tree[key] === 'object' && !Array.isArray(tree[key])) {
        return recursive_fetch(tree[key], path)
      } else {
        throw new Error('path not found')
      }
    } else {
      return tree[key]
    }
  } else {
    throw new Error('path not found')
  }
};

function fetch(label, options = {}) {
  var path
  path = label.split('.')
  path.unshift(locale())
  try {
    return recursive_fetch(translations, path)
  } catch (error) {
    if(options.raise !== false) {
      throw new Error("not found")
    } else {
      return null;
    }
  }
};

function interpolate(input, options) {
  var key, match, string, value
  options = options || {}
  string = input
  if (options['count'] && typeof input === 'object') {
    if (parseInt(options['count']) === 0) {
      string = input['zero'] || input['other']
    } else if (parseInt(options['count'] === 1)) {
      string = input['one'] || input['other']
    } else {
      string = input['other']
    }
    if (!string) {
      throw new Error(`translation for count ${options['count']} not found`)
    }
  }
  for (key in options) {
    value = options[key]
    string = string.replace(new RegExp(`%{${key}}`, 'gi'), value)
  }
  if (typeof string == 'string' && (match = string.match(/\%\{([^}]+)\}/))) {
    throw new Error(`missing interpolation value \"${match[1]}\"`)
  }
  return string
};

function underscore(str) {
  return str.replace(/([a-z\d])([A-Z]+)/g, '$1_$2')
    .replace(/[-\s]+/g, '_')
    .replace(/::/g, '/').toLowerCase()
};

export {I18n as default, translate, human_attribute_name, model_name, localize, fetch}
